/* === Arquivo: src/components/Hero/Hero.js === */

import React from 'react';
import './Hero.css';
import LeadCapture from '../LeadCapture/LeadCapture';

function Hero() {
  return (
    <div className="hero-container">
      <div className="hero-content">
        <h1 className="hero-title">
          Inteligência Artificial com Ética, Transparência e Humanidade.
        </h1>
        <p className="hero-subtitle">
          A Aetheries nasce para auditar e guiar o comportamento ético das IAs 
          que moldam o nosso mundo, garantindo que a inovação caminhe 
          lado a lado com a responsabilidade.
        </p>
        {/* Integração do formulário no Hero */}
        <div className="hero-cta">
          <LeadCapture />
        </div>
      </div>
    </div>
  );
}

export default Hero;